/**
 * Coerce an env-style string to a boolean: 'true' / '1' / 'on' (any case, trimmed) are on; anything else,
 * absent or empty, is off (fail-closed). The one string→bool rule for every `VITE_*` feature flag.
 */
export function coerceFlag(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'on';
}
